export interface DataLayer_Event<T> {
    event: DATA_LAYER_EVENT;
    data?: T,
    user?: DataLayer_User
}

export interface DataLayer_SignUpFunnel_Event {
    event: DATA_LAYER_EVENT;
    funnel_step: DATA_LAYER_SIGN_UP_FUNNEL_STEP_OPTIONS;
    sms_optin?: boolean;
    marketing_optin?: boolean;
    user: DataLayer_SignUpFunnel_User | DataLayer_User;
}

export interface DataLayer_FormSubmission {
    form_id: DATA_LAYER_FORM_SUBMISSION_ID_OPTIONS
}

interface DataLayer_Products {
    ecommerce: DataLayer_Ecommerce;
}

export interface DataLayer_ViewItem extends DataLayer_Products { }
export interface DataLayer_AddToCart extends DataLayer_Products { }
export interface DataLayer_BeginCheckout extends DataLayer_Products { }

export interface DataLayer_ViewItemList {
    ecommerce: {
        item_list_name: string;
        items: DataLayer_CartItem[];
    },
}

export interface DataLayer_Ecommerce {
    currency: DATA_LAYER_ECOMMERCE_CURRENCY_OPTIONS;
    value: number;
    tax?: number;
    shipping?: number;
    tip?: number;
    coupon?: string;
    items: DataLayer_CartItem[];
}

export interface DataLayer_CartItem {
    item_id: string;
    item_name: string;
    price: number;
    discount: number;
    item_category: string;
    item_category2: string;
    item_brand?: string;
    promotion?: string;
    promotion_name?: string;
    quantity: number;
}

export interface DataLayer_User {
    email: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    user_id?: string;
}

export interface DataLayer_Subscribe {
    subscription_name: string;
    quantity: number;
    subscription_value: number;
}

export interface DataLayer_CheckAddress {
    delivery_area: boolean;
}

export interface DataLayer_LoginState {
    status: DATA_LAYER_LOGIN_STATE_OPTIONS;
}

export interface DataLayer_BannerClicked {
    banner_id: string;
    banner_link: string;
}

export interface DataLayer_SignUpFunnel_User {
    email: string;
    street: string;
    city: string;
    state: string;
    postal_code: string;
}

//#region Enums:

export enum DATA_LAYER_EVENT {
    login = 'login', // ok
    sign_up_funnel = 'sign_up_funnel', // pending
    payment_method = 'payment_method', // pending
    sign_up = 'sign_up', // penging
    login_state = 'login_state', // ok
    check_address = 'check_address', // ok
    form_submission = 'form_submission', // ok
    subscribe = 'subscribe', // ok
    view_item_list = 'view_item_list', // ok
    view_item = 'view_item', // ok
    add_to_cart = 'add_to_cart', // ok
    begin_checkout = 'begin_checkout', // partially - remains to validate the key "value"
    banner_click = 'banner_click'
}

export enum DATA_LAYER_FORM_SUBMISSION_ID_OPTIONS {
    newsletter = 'newsletter',
    delivery_area_update = 'delivery_area_update'
}

export enum DATA_LAYER_ECOMMERCE_CURRENCY_OPTIONS {
    usd = 'USD'
}

export enum DATA_LAYER_LOGIN_STATE_OPTIONS {
    logged_in = 'logged_in'
}

export enum DATA_LAYER_SIGN_UP_FUNNEL_STEP_OPTIONS {
    delivery_address = 'delivery_address',
    delivery_area_update = 'delivery_area_update',
    availability = 'availability',
    produce_box = 'produce_box',
    subscriptions = 'subscriptions',
    personal_info = 'personal_info',
    payment_method = 'payment_method',
    account_success = 'account_success'
}

//#endregion